import React, { HtmlHTMLAttributes } from "react"
import clsx from "clsx"
import { FaChevronRight } from "react-icons/fa"

import { Container, FlexBox } from "../wrapper"

interface HeaderOrderProps extends HtmlHTMLAttributes<HTMLDivElement> {
  step: 1 | 2
}

export const HeaderOrder = ({ step, className }: HeaderOrderProps) => {
  const orderSteps = ["Detail Orderan", "Konfirmasi Pembayaran"]

  return (
    <div className={clsx(className)}>
      <Container className="py-2.5">
        <FlexBox className="gap-4">
          {orderSteps.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              <FlexBox
                align="center"
                justify="center"
                className={clsx(
                  "h-6 w-6 rounded-full text-sm text-white",
                  index < step ? "bg-green" : "bg-grey-97 "
                )}
              >
                {index + 1}
              </FlexBox>
              <div className={clsx(index < step ? "text-green" : "text-grey-97 ")}>{item}</div>
              <FaChevronRight className={clsx(index < step ? "text-green" : "text-grey-97 ")} />
            </li>
          ))}
        </FlexBox>
      </Container>
    </div>
  )
}
